import TermsConditionsPage from '../Terms/Terms';

const TermsPage = () => {
  return (
    <>
      <TermsConditionsPage />
    </>
  );
};

export default TermsPage;
